export default __webpack_public_path__ + "static/media/typeinpassword.c41db31f.png";